import React from 'react';
import { buildHierarchyCreateTarget } from './hierarchyCreateTarget';

const ACTIONS = [
  {
    direction: 'superior',
    label: 'Niveau supérieur',
    accessibleName: (itemLabel) =>
      `Ajouter un niveau supérieur à ${itemLabel}`,
  },
  {
    direction: 'peer',
    label: 'Même niveau',
    accessibleName: (itemLabel) =>
      `Ajouter au même niveau que ${itemLabel}`,
  },
  {
    direction: 'child',
    label: 'Sous-niveau',
    accessibleName: (itemLabel) =>
      `Ajouter un sous-niveau à ${itemLabel}`,
  },
];

const HierarchyCreateActions = ({
  label,
  context,
  activeActionKey = '',
  creationLocked = false,
  onOpen,
}) => (
  <div
    role="group"
    aria-label={`Création autour de ${label}`}
    className="flex min-w-0 flex-wrap items-center gap-2"
  >
    {ACTIONS.map((action) => {
      const target = buildHierarchyCreateTarget(context, action.direction);
      const isActive = Boolean(target && target.actionKey === activeActionKey);
      const disabled = !target || creationLocked || isActive;

      return (
        <button
          key={action.direction}
          type="button"
          aria-label={action.accessibleName(label)}
          aria-pressed={isActive}
          disabled={disabled}
          onClick={() => target && !disabled && onOpen?.(target)}
          className="whitespace-nowrap rounded border border-blue-300 px-2 py-1 text-xs font-medium text-blue-700 hover:bg-blue-50 disabled:cursor-not-allowed disabled:border-gray-200 disabled:text-gray-400"
        >
          {action.label}
        </button>
      );
    })}
  </div>
);

export default HierarchyCreateActions;
